import * as React from "react";
import "./dialog.css";

interface Props {
    id: string;
    saveButtonId?: string;
    cancelButtonId?: string;
    heading?: string;
    saveButtonText?: string;
    onSaveButtonClick?: () => void;
    showCancelButton?: boolean;
    showSaveButton?: boolean;
    cancelButtonText?: string;
    isEditForm?: boolean;
    disableSaveButton?: boolean;
    isFullWidth?: boolean;
    hideHeader?:boolean;
}

class CustomModalDialog extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

    }
    render() {
        const { id, heading, children, saveButtonText = "Save", onSaveButtonClick, showCancelButton, showSaveButton = true,
            cancelButtonText, isEditForm, disableSaveButton = false, saveButtonId, cancelButtonId, hideHeader } = this.props;
        const modalClass = isEditForm ? "modal-dialog full-width" : "modal-dialog";
        return (
            <div id={id} className="modal" data-backdrop="false" role="dialog" style={{ zIndex: 9999999999 }}>
                <div className={modalClass}>
                    <div className="modal-content">
                        {!hideHeader && <div className="modal-header">
                            <button type="button" id="CloseModal" className="close" data-dismiss="modal">&times;</button>
                            {heading && <h4 className="modal-title">{heading}</h4>}
                        </div>}
                        <div className="modal-body">
                            {children}
                        </div>
                        <div className="modal-footer">
                            {showSaveButton && <button id={saveButtonId ? saveButtonId : "btnSaveDialog"} type="button" disabled={disableSaveButton} className="btn btn-primary btn-fill" data-dismiss="modal" onClick={onSaveButtonClick}>{saveButtonText}</button>}
                            {showCancelButton && <button id={cancelButtonId ? cancelButtonId : "btnCancelDialog"} type="button" className="btn btn-default btn-fill" data-dismiss="modal">{cancelButtonText ? cancelButtonText : "Cancel"}</button>}
                        </div>

                    </div>

                </div>
            </div>
        )
    }
}
export default CustomModalDialog;



// WEBPACK FOOTER //
// ./src/Components/Shared/Dialogs/CustomModalDialog.tsx